__turbopack_context__.v({
  "icon": "QuickSearch-module__Rp2jLa__icon",
  "quickSearch": "QuickSearch-module__Rp2jLa__quickSearch",
});
